import { combineReducers } from 'redux';
import { AppEventsReducer } from './AppEventsReducer';
import { AuthenticationReducer } from './AuthenticationReducer';
import { BrowserReducer } from './BrowserReducer';
import { ContextMenuReducer } from './ContextMenuReducer';
import { DialogReducer } from './DialogReducer';
import { InteractionReducer } from './InteractionReducer';
import { LyricsViewedReducer } from './LyricsViewedReducer';
import { MediaReducer } from './MediaReducer';
import { PlaybackActionsReducer } from './PlaybackActionsReducer';
import { PlaybackEventsReducer } from './PlaybackEventsReducer';
import { PlaybackStatesReducer } from './PlaybackStatesReducer';
import { PlayQueueReducer } from './PlayQueueReducer';
import { RibbonReducer } from './RibbonReducer';
import { ScrubInfoReducer } from './ScrubInfoReducer';
import { SearchSuggestionsReducer } from './SearchSuggestionsReducer';
import { SkyfireMethodQueueReducer } from './SkyfireMethodQueueReducer';
import { SoftRefreshReducer } from './SoftRefreshReducer';
import { StorageReducer } from './StorageReducer';
import { TemplateStackReducer } from './TemplateStackReducer';
import { TooltipReducer } from './TooltipReducer';
export const RootReducer = combineReducers({
    AppEvents: AppEventsReducer,
    Authentication: AuthenticationReducer,
    Dialog: DialogReducer,
    ContextMenu: ContextMenuReducer,
    Media: MediaReducer,
    InteractionState: InteractionReducer,
    PlaybackActions: PlaybackActionsReducer,
    PlaybackEvents: PlaybackEventsReducer,
    PlaybackStates: PlaybackStatesReducer,
    SkyfireMethodQueue: SkyfireMethodQueueReducer,
    Storage: StorageReducer,
    TemplateStack: TemplateStackReducer,
    SearchSuggestions: SearchSuggestionsReducer,
    LyricsViewed: LyricsViewedReducer,
    BrowserState: BrowserReducer,
    Ribbon: RibbonReducer,
    Tooltip: TooltipReducer,
    PlayQueue: PlayQueueReducer,
    ScrubInfo: ScrubInfoReducer,
    SoftRefresh: SoftRefreshReducer,
});
